import { render, staticRenderFns } from "./CrftEditAppr.vue?vue&type=template&id=4abbe436&scoped=true&"
import script from "./CrftEditAppr.vue?vue&type=script&lang=js&"
export * from "./CrftEditAppr.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4abbe436",
  null
  
)

export default component.exports